import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=7f2239a8&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=7f2239a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2239a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2239a8')) {
      api.createRecord('7f2239a8', component.options)
    } else {
      api.reload('7f2239a8', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=7f2239a8&scoped=true&", function () {
      api.rerender('7f2239a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xRQKNzuFwbny/JS/comp/GuestBoxKids.vue"
export default component.exports